var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M1365.333 682.667C1365.333 305.64 1059.693 0 682.667 0S0 305.64 0 682.667c0 340.738 249.641 623.16 576 674.373V880H402.667V682.667H576v-150.4c0-171.094 101.916-265.6 257.853-265.6 74.69 0 152.813 13.333 152.813 13.333v168h-86.082c-84.805 0-111.25 52.623-111.25 106.61v128.057h189.332L948.4 880H789.333v477.04c326.359-51.213 576-333.635 576-674.373"}));
}

Facebook.defaultProps = {"width":"1365.333","height":"1365.333","viewBox":"0 0 1365.333 1365.333"};

module.exports = Facebook;

Facebook.default = Facebook;
